import React, { Component } from 'react';

import { ref, set } from 'firebase/database';

import AppChrome from '../layout/AppChrome';

class MonthlySummaryStop extends Component {

    constructor(props) {
       super(props);
       this.state = { optedOut : false };
    }

    setMonthlySummaryOptOut = () => {
      if (this.props.firebase.user && !this.state.optedOut) {
        set(ref(this.props.firebase.database, 'users/' + this.props.firebase.user.uid + '/settings/monthlySummaryOptOut'), true)
        .then(() => {
            this.setState({ optedOut : true })
         })
        .catch((error) => {
          alert("Error writing document: ", error);
        });
      }
    }

    componentWillMount = () => {
      this.setMonthlySummaryOptOut();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
      this.setMonthlySummaryOptOut();
    }

    componentWillUnmount() {
    }

    render = () => {
      var user = this.props.firebase.user
      var history = this.props.history;

      if (user && !user.emailVerified)
        this.props.history.push("/verify-email");

      return (
        <AppChrome title="Monthly Summary Opt out" history={history} requireLogin={true} firebase={this.props.firebase} back={true} tab="Today">
            <div><p>You have successfully opted out of monthly summary emails</p></div>
        </AppChrome>
      )      
    }
}

export default MonthlySummaryStop;